var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChartDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 68,
    viewBox: "0 0 80 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2 54.09L28.11 35V34.99V8",
    stroke: "#D5DBDB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.11 34.9899L47.19 15.9099",
    stroke: "#D5DBDB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.11 62C43.0217 62 55.11 49.9117 55.11 35C55.11 20.0883 43.0217 8 28.11 8C13.1983 8 1.10999 20.0883 1.10999 35C1.10999 49.9117 13.1983 62 28.11 62Z",
    stroke: "#D5DBDB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.11 48H60.11",
    stroke: "#D5DBDB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.11 22H60.11",
    stroke: "#D5DBDB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.11 35H60.11",
    stroke: "#D5DBDB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.11 9H54.11L50.11 13",
    stroke: "#D5DBDB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartDark);
export default __webpack_public_path__ + "static/media/pie-chart-dark.a4a9afae3e9bc3e524583bb7e985246c.svg";
export { ForwardRef as ReactComponent };